import { render, staticRenderFns } from "./ClassicOrNxt.vue?vue&type=template&id=32f00189&"
import script from "./ClassicOrNxt.vue?vue&type=script&lang=js&"
export * from "./ClassicOrNxt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports